import type { ComponentProps } from "react"
import { Fragment } from "react"
import { Glyph, Prose } from "@motleyhand/design"
import BaseMarkdown from "markdown-to-jsx"

type Props = Pick<ComponentProps<typeof BaseMarkdown>, "children" | "className">

export default function Markdown({ children, className }: Props) {
  return (
    <Prose className={className}>
      <BaseMarkdown
        options={{
          wrapper: Fragment,
          forceBlock: true,
          overrides: {
            h1: ({ children, ...props }: ComponentProps<"h1">) => (
              <h1 {...props}>
                <Glyph variant="staggered-bars" size={24} className="mr-2" />
                {children}
              </h1>
            ),
          },
        }}
      >
        {children}
      </BaseMarkdown>
    </Prose>
  )
}
